import { render, staticRenderFns } from "./langEdit.vue?vue&type=template&id=58861d4f&scoped=true&"
import script from "./langEdit.vue?vue&type=script&lang=js&"
export * from "./langEdit.vue?vue&type=script&lang=js&"
import style0 from "./langEdit.vue?vue&type=style&index=0&id=58861d4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58861d4f",
  null
  
)

export default component.exports